/**
 * Router scaffold — ADR-095 Phase 3.1.
 *
 * Routes-as-data pattern: this module exports a `routes: RouteObject[]`
 * constant so tests can construct a `createMemoryRouter(routes)` without
 * touching `window.location` (jsdom safe). The actual `createBrowserRouter`
 * instance is constructed in `main.tsx` for the live entry point.
 *
 * Phase 3 route plan (per ADR-095 §4.3 — each route lands in a subsequent
 * sub-commit; this scaffold ships ONLY `/`):
 *   /                       — main app (Phase 3.1, this commit)
 *   /c/:conversationId      — deep-linked conversation (Phase 3.2)
 *   /c/:id?job=:jobId       — active job rehydration (Phase 3.3)
 *   /c/:id#m_msg_xyz        — message anchor scroll (Phase 3.4)
 *
 * MSAL redirect.html is a separate Vite entry (`rollupOptions.input.redirect`
 * in vite.config.ts) — NOT routed by this router. The MSAL callback fragment
 * is parsed on `redirect.html` then redirects back to the main app's URL.
 */

import { Navigate, type RouteObject } from "react-router-dom";

import { App } from "@/App";

export const routes: RouteObject[] = [
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/c/:conversationId",
    element: <App />,
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
];
